<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="점검내용 목록"
          :merge="grid.merge"
          :columns="grid.columns"
          :data="grid.data"
          :gridHeight="grid.height"
          :editable="editable"
          :usePaging="false"
          :isExcelDown="false"
          :filtering="true"
          :isFullScreen="false"
          :columnSetting="false"
          :selection="popupParam.type"
          rowKey="saiSafetyHealthyDetailId"
          @rowDblclick="rowDblclick"
        >
          <template slot="table-button">
            <q-btn-group outline >
              <!--검색-->
              <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
              <!--선택-->
              <c-btn v-if="editable" label="LBLSELECT" icon="check" @btnClicked="select" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'safetyHealthyMstPopup',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        type: 'multiple',
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    contentHeight: null,
  },
  data() {
    return {
      searchParam: {
        plantCd: null,
        useFlag: 'Y'
      },
      editable: true,
      grid: {
        merge: [
          { index: 0, colName: 'plantCd', },
          { index: 1, colName: 'saiSafetyHealthyId', },
        ],
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            //사업장
            label: 'LBLPLANT',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'targetName',
            field: 'targetName',
            label: '구분',
            align: 'left',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'detailName',
            field: 'detailName',
            label: '점검내용',
            style: 'width:250px',
            align: 'left',
            sortable: true,
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '해당팀',
            align: 'center',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'inspectionCycle',
            field: 'inspectionCycle',
            label: '점검주기',
            align: 'center',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'managerName',
            field: 'managerName',
            label: '담당자',
            align: 'left',
            style: 'width:200px',
            sortable: false
          },
          {
            name: 'relatedEvidence',
            field: 'relatedEvidence',
            label: '관련근거',
            align: 'left',
            style: 'width:250px',
            type: 'html',
            sortable: false
          },
        ],
        data: [],
        height: '400px',
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
    contentHeight() {
      let height = (this.contentHeight - 300);
      if (height < 500) {
        height = 500;
      }
      this.grid.height = height + 'px'
    }
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.safetyHealthy.base.detail.list.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: '항목을 하나 이상 선택하세요.',
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === 'single') {
        this.$emit('closePopup', [row]);
      }
    },
  }
};
</script>